<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/3/logo.png`" :width="2.79" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/3/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand3" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn'}">
			<p class="field_1" :style="{'padding':lang=='zh-cn'? '0 0.58rem' : ''}" v-html="detail.field_1"></p>
			<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.58rem' : '0.72rem','padding':lang=='zh-cn'? '0 0.58rem' : '' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.01rem' : '1.82rem' }"><img :src="detail.field_3" width="100%" /></p>
			<p class="brandImg_style3" style="margin-top:2.25rem"><img :src="detail.field_4" width="100%" /></p>
			<div :class="{'brandWrapModule1': lang=='zh-cn', 'brandWrapModule letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '2.16rem' : '1.72rem' }">
				<p :class="{'field_3': lang=='zh-cn', 'field_1': lang == 'en-us'}" v-html="detail.field_5"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.44rem' : '0.74rem','width': lang=='zh-cn'? '100%' : '106%'}" v-html="detail.field_6"></p>
			</div>
			<div class="pressImgWrap" :style="{ 'marginTop': lang=='zh-cn'? '2.06rem' : '1.88rem' }">
				<img :src="detail.field_7" width="100%" />
				<img class="upImg" :src="detail.field_8" width="100%" />
			</div>
			<div :class="{'brandWrapModule1': lang=='zh-cn', 'brandWrapModule letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '5.65rem' : '5rem' }">
				<p class="field_1" v-html="detail.field_9"></p>
				<p :class="{'field_3': lang=='zh-cn', 'field_1': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.17rem' : '0' }" v-html="detail.field_10"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.34rem' : '0.24rem','width': lang=='zh-cn'? '100%' : '106%' }" v-html="detail.field_11"></p>
			</div>
			<p class="brandImg_style3" :style="{ 'marginTop': lang=='zh-cn'? '1.31rem' : '0.48rem' }"><img :src="detail.field_12" width="100%" /></p>
			<div :class="{'brandWrapModule1': lang=='zh-cn', 'brandWrapModule letterSpace': lang == 'en-us'}" style="margin-top:2.27rem">
				<p class="field_1" v-html="detail.field_13"></p>
				<p :class="{'field_3': lang=='zh-cn', 'field_1': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.17rem' : '0' }" v-html="detail.field_14"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.34rem' : '0.42rem','width': lang=='zh-cn'? '100%' : '106%' }" v-html="detail.field_15"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '2.09rem' : '1.52rem' }"><img :src="detail.field_16" width="100%" /></p>
			<div :class="{'brandWrapModule1': lang=='zh-cn', 'brandWrapModule letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '1.47rem' : '1.21rem' }">
				<p class="field_1" v-html="detail.field_17"></p>
				<p :class="{'field_3': lang=='zh-cn', 'field_1': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.17rem' : '0' }" v-html="detail.field_18"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.34rem' : '0.53rem','letter-spacing': lang=='zh-cn'? '-0.5px' : '0','width': lang=='zh-cn'? '100%' : '106%' }" v-html="detail.field_19"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '2.06rem' : '0.92rem' }"><img :src="detail.field_20" width="100%" /></p>
			<div class="brandWrapModule" :class="{'letterSpace': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '1.56rem' : '1.62rem' }">
				<p class="field_1" v-html="detail.field_21"></p>
				<p :class="{'field_3': lang=='zh-cn', 'field_1': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.1rem' : '0' }" v-html="detail.field_22"></p>
				<p class="field_2" :style="{ 'marginTop': lang=='zh-cn'? '0.35rem' : '0.53rem','width': lang=='zh-cn'? '100%' : '106%' }" v-html="detail.field_23"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '2.06rem' : '1.32rem' }"><img :src="detail.field_24" width="100%" /></p>
			<a class="brandLinkWrap white" href="http://www.heilanhome.cn" target="_blank">
				<p class="brandLink1">{{ $t('shoplink') }}</p>
				<p class="brandLink2">www.heilanhome.cn</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(10)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand3.vue